/**
 * StatusSms
 * @author Simpli CLI generator
 */
import {$, ID, Resource, TAG} from 'simpli-web-sdk'
import {
  ValidationMaxLength,
  ValidationRequired,
} from 'simpli-web-sdk'
import StatusSmsSchema from '@/schema/StatusSms.schema'

export default class StatusSms extends Resource {
  static readonly INICIO_ENTREGA = 1
  static readonly FIM_ENTREGA = 2
  static readonly OCORRENCIA = 3

  readonly $name: string = 'StatusSms'

  readonly $endpoint: string = '/user/sms/status{/id}'

  get $schema() {
    return StatusSmsSchema(this)
  }

  get $id() {
    return this.idStatusPk
  }
  set $id(val: ID) {
    this.idStatusPk = val
  }
  get $tag() {
    return this.nome
  }
  set $tag(val: TAG) {
    this.nome = val
  }

  idStatusPk: ID = 0

  @ValidationRequired()
  @ValidationMaxLength(100)
  nome: string = ''

  @ValidationRequired()
  ativo: boolean = false
}
